"use client";

import type { HeaderProps } from "./types/header.types";
import { headerStyles, headerContainerStyles } from "./styles/header.styles";

import { HeaderProvider } from "./header.context";

import { HeaderLogo } from "./header-logo";
import { HeaderActions } from "./header-actions";
import { HeaderNavbar } from "./header-navbar";
import { HeaderMobileMenu } from "./header-mobile-menu";
import { HeaderMobileMenuToggle } from "./header-mobile-menu-toggle";
import { HeaderMobileMenuFooter } from "./header-mobile-menu-footer";

type HeaderComponents = {
  Logo: typeof HeaderLogo;
  Actions: typeof HeaderActions;
  Navbar: typeof HeaderNavbar;
  MobileMenu: typeof HeaderMobileMenu;
  MobileMenuToggle: typeof HeaderMobileMenuToggle;
  MobileMenuFooter: typeof HeaderMobileMenuFooter;
};

export const Header: React.FC<HeaderProps> & HeaderComponents = (props) => {
  const { children, onMenuOpenChange, ...rest } = props;

  return (
    <HeaderProvider onMenuOpenChange={onMenuOpenChange}>
      <header className={headerStyles()} {...rest}>
        <div className={headerContainerStyles()}>{children}</div>
      </header>
    </HeaderProvider>
  );
};

Header.displayName = "Header";

Header.Logo = HeaderLogo;
Header.Actions = HeaderActions;
Header.Navbar = HeaderNavbar;
Header.MobileMenu = HeaderMobileMenu;
Header.MobileMenuToggle = HeaderMobileMenuToggle;
Header.MobileMenuFooter = HeaderMobileMenuFooter;
